module.exports = __webpack_public_path__ + "media/images/homes/Stockadjustments-489af41e744afb6eb8a87bda931d3dcf.png";